<template>
  <div>
    <div style="width: 900px;margin: 0 auto;text-align: center;font-size: 30px;">
      个人信息
    </div>
    <div class="smains">
      <div class="mainleft">
        <div style="margin-top: 70px;margin-bottom: 30px;">
          <el-form :model="updataForm" ref="updataForm" style="margin-top: 30px;">
            <el-form-item prop="name">
              昵称:<el-input type="text" v-model="updataForm.name" style="width: 280px;margin-left: 10px;"></el-input>
            </el-form-item>
            <el-form-item prop="signature">
              电话:<el-input type="text" v-model="updataForm.phone" style="width: 280px;margin-left: 10px;" :disabled="disableds"></el-input>
            </el-form-item>
            <el-form-item prop="signature">
              邮箱:<el-input type="text" v-model="updataForm.email" style="width: 280px;margin-left: 10px;" :disabled="disableds"></el-input>
            </el-form-item>
            <el-form-item prop="sex">
              性别:<el-radio v-model="updataForm.sex" label="男" style="margin-left: 30px;">男</el-radio>
              <el-radio v-model="updataForm.sex" label="女">女</el-radio>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="width: 150px;" :loading="loading" @click="opendraweList()" v-if="disableds">修改电话/邮箱</el-button>
              <el-button type="primary" style="width: 100px;" :loading="loading" @click="updateUser">保&nbsp;&nbsp;&nbsp;存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="mainright">
        <div style="margin-top: 70px;margin-bottom: 30px;">
          <div style="width: 202px;height: 202px;border: 0.05rem solid #aaa;">
            <el-upload
              ref="upload_img_photo"
              class="avatar-uploader"
              action="/api/updateAdminPhoto"
              :data="updataForm"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :on-change="changephoto"
              :auto-upload="false"
              :headers="myHeaders">
              <img v-if="updataForm.photo" :src="updataForm.photo" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div style="margin-top: 20px; width: 202px;text-align: center;">
            点击图片更改头像
          </div>
        </div>
      </div>
    </div>

    <!--其他窗口-->
    <el-drawer
      title="手机号码修改"
      :visible.sync="drawer"
      :with-header="false">
      <!--第一步-->
      <div id="Uone">
        <div style="width: 350px;margin: 0 auto;margin-top: 50px;">
          <i class="el-icon-warning-outline" style="color: #ff6700;"></i>如果当前手机号还在使用，请选择手机号验证，如果没有请选择邮箱验证或者联系客服！！！
        </div>
        <div style="width: 300px;margin: 0 auto;margin-top: 20px;">
          <el-radio v-model="updatephoneradio" label="1" border>手机号验证</el-radio>
          <el-radio v-model="updatephoneradio" label="2" border>邮箱验证</el-radio>
        </div>
        <div style="width: 300px;margin: 0 auto;" v-if="updatephoneradio=='1'">
          <el-form :model="updatephoneForm" style="margin-top: 40px;">
            <el-form-item prop="username">
              <el-input type="text" v-model="updatephoneForm.phone" placeholder="电话号码" :disabled="true">
                <template slot="prepend"><i class="el-icon-message" style="font-size: 20px; color: #000000;"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input type="text" v-model="updatephoneForm.codes" placeholder="验证码">
                <template slot="prepend"><i class="el-icon-postcard" style="font-size: 20px;color: #000000;"></i></template>
                <a href="javascript:;" slot="append" @click="getlogincode">
                  <img :src="logincode.img" alt=" " style="width: 80px;height: 33px;" >
                </a>
              </el-input>
            </el-form-item>
            <el-form-item prop="phonecode">
              <el-input type="text" v-model="updatephoneForm.code" placeholder="手机验证码">
                <template slot="prepend"><i class="el-icon-postcard" style="font-size: 20px;color: #000000;"></i></template>
                <el-button slot="append" size="mini" @click="getPhoneCode" :disabled="button_tof">{{content}}</el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="loading" style="width: 300px;" @click="nextPD">下一步</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div style="width: 300px;margin: 0 auto;" v-if="updatephoneradio=='2'">
          <el-form :model="updatephoneForm" style="margin-top: 40px;">
            <el-form-item prop="username">
              <el-input type="text" v-model="updatephoneForm.email" placeholder="邮箱号" :disabled="true">
                <template slot="prepend"><i class="el-icon-message" style="font-size: 20px; color: #000000;"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input type="text" v-model="updatephoneForm.codes" placeholder="验证码">
                <template slot="prepend"><i class="el-icon-postcard" style="font-size: 20px;color: #000000;"></i></template>
                <a href="javascript:;" slot="append" @click="getlogincode">
                  <img :src="logincode.img" alt=" " style="width: 80px;height: 33px;" >
                </a>
              </el-input>
            </el-form-item>
            <el-form-item prop="phonecode">
              <el-input type="text" v-model="updatephoneForm.code" placeholder="邮箱验证码">
                <template slot="prepend"><i class="el-icon-postcard" style="font-size: 20px;color: #000000;"></i></template>
                <el-button slot="append" size="mini" @click="updatapassEmailCode" :disabled="button_tof">{{content}}</el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="loading" style="width: 300px;" @click="nextPD">下一步</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-drawer>

    <div class="Orderinfordiv" id="updateIMage">
      <imageCJ ref="child_IMAGE" @fatherMethod="fatherMethod" width="1" height="1" :img_date="img_date" div_name="updateIMage"></imageCJ>
    </div>

  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  import {codeAPI} from '@/api/codeAPI'
  import imageCJ from '@/img_update/images_UP.vue'//头像裁剪
  let Atoken=sessionStorage.getItem("Atoken")
export default {
  components: {
    'imageCJ': imageCJ,
  },
  data () {
    return {
      //头像裁剪
      img_date:null,
      newfile:null,
      //
      updataForm: {
        id:'',
        name: '',
        sex:'',
        email:'',
        phone:'',
        photo:''
      },
      //登录验证码
      logincode:{
        logincode:'',
        img:''
      },
      //手机短信计时器
      phonecontent: '获取',
      phonetotalTime: 120,
      phonecanClick: true ,//添加canClick
      phonebutton_tof:false,
      updatephoneForm: {
        id:'',
        email: '',
        phone:'',
        codes:'',
        code:'',
        type:'1',
        CodeType:2,//0代表初始值,1代表直接输入电话或者邮箱，2代表用户获取
        GetType:0,//进行分类分解。int型，0代表初始值,1代表电话，2代表邮箱
      },
      //修改电话
      updatephone:{
        id:'',
        phone:'',
        email:'@',
        code:'',
        type:'1',
      },
      //修改邮箱
      updateemail:{
        id:'',
        email:'',
        code:'',
      },
      //
      updatephoneradio:'1',//验证方式
      //抽屉
      drawer:false,//手机修改
      //计时器
      content: '获取',
      totalTime: 120,
      canClick: true ,//添加canClick
      button_tof:false,
      //
      disableds:true,//框体禁用
      loading: false,   //登陆加载效果
      //图片Token获取
      myHeaders: {
        Atoken:Atoken,
      },
      updataForms: {
        id:'',
        name: '',
        sex:'',
        email:'',
        phone:'',
      },
    }
  },
  //页面开启时执行
  mounted(){
    this.getuserinfor();
    this.getlogincode();
  },
  //方法
  methods: {
    fatherMethod(data){
      this.newfile=data;
      this.$refs['upload_img_photo'].clearFiles();//清除文件
      this.$refs['upload_img_photo'].handleStart(data);//选择文件后的赋值方法
      this.$refs.upload_img_photo.submit();
      //console.log("123"+data);
    },
    //改变图片框状态
    changephoto(file, fileList){
      //console.log(file);
      if(this.newfile!==null&&file.name==this.newfile.name){
        return false;
      }else{
        this.img_date=file;
        this.openInformation();
      }
    },
    openInformation(){
      document.getElementById('updateIMage').style.display='block';
      document.getElementById('zhedang').style.display='block';
    },
    //验证下一步
    nextPD(){
      let PDnumber=this.updatephoneradio;
      if(PDnumber=="1"){
        //手机验证
        this.phone_update_pass();
      }else if(PDnumber=="2"){
        //邮箱验证
        this.email_update_pass();
      }else{
        return false;
      }
    },
    //打开第二步
    openTwo(){
      this.loading=false;
      this.drawer=false;
      this.disableds=false;
    },
    //判定手机和邮箱验证码是否正确对应
    phone_update_pass(){
      if(this.updatephoneForm.code.length<=0){
        this.$message({
          message: '请输入验证码',
          type: 'error'
        });
        return false;
      }
      this.updatephoneForm.code=this.updatephoneForm.code.toLocaleLowerCase();
      this.loading=true;
      commonAPI('queryPDphoneCode', this.updatephoneForm).then(res => {
      let data = res.data;
      if(this.response.response(data)){
        this.loading=false;
        this.openTwo()
      }
      }).catch(error=>{
        //this.loading = false;
        this.$notify({//这里采用element ui的一个错误显示效果模板
        title: '提示',
        message: error.message,
        position: 'bottom-right',
        type: 'error'
      });
      this.loading=false;
      })
    },
    email_update_pass(){
      if(this.updatephoneForm.code.length<=0){
        this.$message({
          message: '请输入验证码',
          type: 'error'
        });
        return false;
      }
      this.updatephoneForm.code=this.updatephoneForm.code.toLocaleLowerCase();
      this.loading=true;
      //封装的公共请求API
      commonAPI('queryPDEmailCode', this.updatephoneForm).then(res => {
      let data = res.data;
      if(this.response.response(data)){
        this.loading=false;
        this.openTwo()
      }
      }).catch(error=>{
        //this.loading = false;
        this.$notify({//这里采用element ui的一个错误显示效果模板
        title: '提示',
        message: error.message,
        position: 'bottom-right',
        type: 'error'
      });
      this.loading=false;
      })
    },
    //修改密码邮箱验证码
    updatapassEmailCode(){
      let emailPD=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if(this.updatephoneForm.email.length<=0){
        this.$message({
          message: '请输入邮箱号码',
          type: 'error'
        });
        return false;
      }
      if(this.updatephoneForm.codes.length<=0){
        this.$message({
          message: '请输入验证码',
          type: 'error'
        });
        return false;
      }
      //判定验证码是否正确
      let codes=this.updatephoneForm.codes;
      let PD = eval(/^\d+$/);
      let codePD=this.logincode.logincode;
      if(PD.test(codePD)){
        if (codes.length === 0) {
          this.$message({
            message: '请输入验证码',
            type: 'error'
          });
          return false;
        } else if(codePD*1!==codes*1){
          this.$message({
            message: '验证码错误',
            type: 'error'
          });
          this.getlogincode();
          return false;
        }
      }else{
        if (codes.length === 0) {
          this.$message({
            message: '请输入验证码',
            type: 'error'
          });
          return false;
        } else if(codePD.toUpperCase()!==codes.toUpperCase()){
          this.$message({
            message: '验证码错误',
            type: 'error'
          });
          this.getlogincode();
          return false;
        }
      }
      this.countDown();
      this.updatephoneForm.GetType=2;
      commonAPI('GetP_ECode', this.updatephoneForm).then(res => {
        this.getlogincode();
        let data=res.data
        if(this.response.response_code(data)){}
      })
    },
    //倒计时
    countDown () {
     if (!this.canClick) return  //改动的是这两行代码
     this.button_tof = true
     this.canClick = false
     this.content = this.totalTime
     let clock = window.setInterval(() => {
      this.totalTime--
      this.content = this.totalTime
      if (this.totalTime <= 0) {
       window.clearInterval(clock)
       this.content = '获取'
       this.totalTime = 120
       this.canClick = true  //这里重新开启
       this.button_tof = false
       this.registerForm.emailinput = false;
      }
     },1000)
    },
    getPhoneCode(){
      if(this.updatephoneForm.phone.length<=0){
        this.$message({
          message: '请输入电话号码',
          type: 'error'
        });
        return false;
      }
      if(this.updatephoneForm.codes.length<=0){
        this.$message({
          message: '请输入验证码',
          type: 'error'
        });
        return false;
      }
      //判定验证码是否正确
        let codes=this.updatephoneForm.codes;
        let PD = eval(/^\d+$/);
        let codePD=this.logincode.logincode;
        if(PD.test(codePD)){
          if (codes.length === 0) {
            this.$message({
              message: '请输入验证码',
              type: 'error'
            });
            return false;
          } else if(codePD*1!==codes*1){
            this.$message({
              message: '验证码错误',
              type: 'error'
            });
            this.getlogincode();
            return false;
          }
        }else{
          if (codes.length === 0) {
            this.$message({
              message: '请输入验证码',
              type: 'error'
            });
            return false;
          } else if(codePD.toUpperCase()!==codes.toUpperCase()){
            this.$message({
              message: '验证码错误',
              type: 'error'
            });
            this.getlogincode();
            return false;
          }
        }
        this.countDown();
        this.updatephoneForm.GetType=1;
        commonAPI('GetP_ECode', this.updatephoneForm).then(res => {
          this.getlogincode();
          let data=res.data
          if(this.response.response_code(data)){}
          //console.log(i)
        })
      },
    //获取登录验证码方法
    getlogincode(){
      commonAPI('getLoginCodes', this.logincode).then(res => {
        let data=res.data
        this.logincode.logincode=data
        codeAPI('getLoginCode', this.logincode).then(res => {
          let url = window.URL.createObjectURL(res.data);
          this.logincode.img=url
          //console.log(url)
        })
      })
    },
    //打开抽屉栏
    opendraweList(){
      this.drawer = true
      this.updatephoneForm.email=this.updataForm.email
      this.updatephoneForm.phone=this.updataForm.phone
      this.updatephoneForm.id=this.$store.state.a_id;
    },
    //
    getuserinfor(){
      this.updataForm.id=this.$store.state.a_id;
      this.judgeLogin();
    },
    //获取信息方法
    judgeLogin(){
      if(this.updataForm.id!=""){
        commonAPI('queryAdmininfor', this.updataForm).then(res => {
          let data=res.data.data[0];
          this.updataForm.id=data.id;
          this.updataForm.name=data.name;
          this.updataForm.photo=data.photo;
          this.updataForm.sex=data.sex;
          this.updataForm.email=data.email;
          this.updataForm.phone=data.phone;
          //
          this.updataForms.id=data.id;
          this.updataForms.name=data.name;
          this.updataForms.sex=data.sex;
          this.updataForms.email=data.email;
          this.updataForms.phone=data.phone;
        });
      }
    },
    //图片信息修改
    handleAvatarSuccess(res, file) {
      if(this.response.response(res)){
        this.updataForm.photo = URL.createObjectURL(file.raw);
      }
    },
    beforeAvatarUpload(file) {
    let types = ['image/jpeg', 'image/gif', 'image/bmp', 'image/png'];
    const isImage = types.includes(file.type);
    const isLtSize = file.size / 1024 / 1024 < 5;
    if (!isImage) {
    this.$message.error('上传头像图片只能是 JPG、GIF、BMP、PNG 格式!');
    }
    if (!isLtSize) {
    this.$message.error('上传头像图片大小不能超过 5MB!');
    }
    return isImage && isLtSize;
    },
    //更新信息
    updateUser(){
      let phone=this.updataForm.phone
      let email=this.updataForm.email
      //判定是否作出修改
      if(this.updataForm.name==this.updataForms.name&&this.updataForm.phone==this.updataForms.phone&&this.updataForm.email==this.updataForms.email&&this.updataForm.sex==this.updataForms.sex){
        this.$message({
          message: '没有进行任何修改',
          type: 'warning'
        });
        return false;
      }
      if(this.updataForm.email==""||this.updataForm.email==null||this.updataForm.email=="null"){
        this.$message({
          message: '请将数据填写完整',
          type: 'warning'
        });
        return false;
      }
      if(this.updataForm.phone==phone){
        this.updataForm.phone="";
      }
      if(this.updataForm.email==email){
        this.updataForm.email=""
      }
      this.loading=true;
      commonAPI('updateAdmininfor', this.updataForm).then(res => {
        let data = res.data;
        if(this.response.response(data)){
          this.disableds=true;
          this.loading=false;
          this.judgeLogin();
          this.updateInfor_C();
        }else{
          this.loading=false;
        }
        }).catch(error=>{
        this.$notify({//这里采用element ui的一个错误显示效果模板
          title: '提示',
          message: error.message,
          position: 'bottom-right',
          type: 'error'
        });
        this.loading=false;
        })
    },
    //更新现阶段
    updateInfor_C(){
      this.$emit("parentHandle", "updateInformation")
    },
  }
}
</script>

<style scoped>
  .smains{
    width: 900px;
    height: 600px;
    margin: 0 auto;
    margin-top: 50px;
    overflow: hidden;
  }
  .mainleft{
    float: left;
    width: 50%;
    height: 100%;
    border-right: 1px solid #000;
    text-align: center;
    margin-right: 4%;
    overflow: hidden;
  }
  .mainright{
    overflow: hidden;
    float: left;
    width: 40%;
    height: 100%;
    margin-left: 4%;
  }

  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 198px;
      height: 198px;
      line-height: 198px;
      text-align: center;
    }
    .avatar {
      width: 200px;
      height: 200px;
      display: block;
    }

    .bangdingall{
      width: 100%;border: 0.05rem solid #aaa;background-color: #F8F8F8;height: 80px;overflow: hidden;
    }
    .bangdingall a:hover{
      color: #ff6700;
    }

    /**Orderinfor框架*/
    .Orderinfordiv{
      position: fixed;
      top: 17%;
      left:0;
      right:0;
      bottom: 0;
      margin:0 auto;
      padding: 20px;
      border: 0px solid #ddd;
      z-index:2002;
      overflow: auto;
      display: none;
    }
    .OrderinforForm{
      margin: 0 auto;
      width: 1200px;
      background-color: #fff;
      -webkit-box-shadow: #333 0px 5px 5px;
      -moz-box-shadow: #333 0px 5px 5px;
      box-shadow: #333 0px 5px 5px;
    }
    .OrderinforForm a{
      color: #fff;
    }
    .OrderinforForm a:hover{
      color: #d6d6d6;
    }
    .playlistbox_botton{
       width: 900px;margin: 0 auto;overflow: hidden;height: 633px;
       overflow-y: scroll;
     }
     /**滚动条样式*/
     .playlistbox_botton::-webkit-scrollbar{
       width: 5px;
     }
     .playlistbox_botton::-webkit-scrollbar-thumb{
       border-radius: 10px;
       -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
       background: #535353;
     }
     .playlistbox_botton::-webkit-scrollbar-thumb{
       -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
       border-radius: 10px;
       background: #EDEDED;
     }
</style>



// WEBPACK FOOTER //
// src/admin/views/update/UpdateInfor.vue